import { render } from "./createEvent.vue?vue&type=template&id=88d12096&scoped=true"
import script from "./createEvent.vue?vue&type=script&lang=ts"
export * from "./createEvent.vue?vue&type=script&lang=ts"

import "./createEvent.vue?vue&type=style&index=0&id=88d12096&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-88d12096"

export default script